"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }

var _NKGUWTUCcjs = require('./NKGUWTUC.cjs');



var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');

// src/tooltip/tooltip-store.ts
var _tooltipstore = require('@ariakit/core/tooltip/tooltip-store'); var Core = _interopRequireWildcard(_tooltipstore);
function useTooltipStoreProps(store, update, props) {
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "type");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "skipTimeout");
  return _NKGUWTUCcjs.useHovercardStoreProps.call(void 0, store, update, props);
}
function useTooltipStore(props = {}) {
  const [store, update] = _FH6HQ5JNcjs.useStore.call(void 0, Core.createTooltipStore, props);
  return useTooltipStoreProps(store, update, props);
}




exports.useTooltipStoreProps = useTooltipStoreProps; exports.useTooltipStore = useTooltipStore;
